import moment from "moment";

export const getCurrentDate = (format) => {
  return moment().format(format);
};

export const transformDatetimeToFormat = (
  datetime,
  format = "YYYY-MM-DD HH:mm:ss"
) => {
  if (moment.utc(datetime).isValid())
    return moment.utc(datetime).local().format(format);
  return "";
};

export const transformUniversalDateToLocalDate = universalDate => {
  const inputFormat = "YYYY-MM-DD";
  const outputFormat = "DD-MM-YYYY";

  return moment(universalDate, inputFormat).format(outputFormat);
}

export const transformDateToUniversalString = date => {
  return date.format("YYYY-MM-DD")
}
